let ctx = null;
const ac = () => {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
};

export const NOTE = { C4: 261.63, D4: 293.66, E4: 329.63, F4: 349.23, G4: 392, A4: 440, B4: 493.88, C5: 523.25, D5: 587.33, E5: 659.25, G5: 783.99 };
export const PENTA = [NOTE.C4, NOTE.D4, NOTE.E4, NOTE.G4, NOTE.A4, NOTE.C5, NOTE.D5, NOTE.E5];

export const tone = (freq, dur = 0.5, { type = "sine", vol = 0.18, at = 0, out } = {}) => {
  const c = ac(), t = c.currentTime + at, o = c.createOscillator(), g = c.createGain();
  o.type = type; o.frequency.value = freq;
  g.gain.setValueAtTime(0.0001, t);
  g.gain.exponentialRampToValueAtTime(vol, t + 0.02);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.connect(g).connect(out || c.destination);
  o.start(t); o.stop(t + dur + 0.05);
};

export const pop = () => {
  const c = ac(), t = c.currentTime, o = c.createOscillator(), g = c.createGain();
  o.frequency.setValueAtTime(PENTA[Math.floor(Math.random() * PENTA.length)] * 2, t);
  o.frequency.exponentialRampToValueAtTime(120, t + 0.12);
  g.gain.setValueAtTime(0.25, t); g.gain.exponentialRampToValueAtTime(0.0001, t + 0.15);
  o.connect(g).connect(c.destination); o.start(t); o.stop(t + 0.2);
};

export const drum = (kind) => {
  const c = ac(), t = c.currentTime;
  if (kind === "boom") {
    const o = c.createOscillator(), g = c.createGain();
    o.frequency.setValueAtTime(140, t); o.frequency.exponentialRampToValueAtTime(45, t + 0.35);
    g.gain.setValueAtTime(0.5, t); g.gain.exponentialRampToValueAtTime(0.0001, t + 0.4);
    o.connect(g).connect(c.destination); o.start(t); o.stop(t + 0.45);
    return;
  }
  const len = kind === "shake" ? 0.12 : 0.2, buf = c.createBuffer(1, c.sampleRate * len, c.sampleRate), d = buf.getChannelData(0);
  for (let i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / d.length);
  const src = c.createBufferSource(), f = c.createBiquadFilter(), g = c.createGain();
  src.buffer = buf; f.type = kind === "shake" ? "highpass" : "bandpass"; f.frequency.value = kind === "shake" ? 6000 : 1800;
  g.gain.value = kind === "shake" ? 0.15 : 0.3;
  src.connect(f).connect(g).connect(c.destination); src.start(t);
};

export const playMelody = (notes, { tempo = 0.45, bedtime = false, onNote } = {}) => {
  const timers = [], c = ac(), bus = c.createGain();
  bus.connect(c.destination);
  let at = 0;
  notes.forEach(([n, beats], i) => {
    const dur = beats * tempo;
    tone(NOTE[n], dur * 0.95, { type: bedtime ? "triangle" : "sine", vol: bedtime ? 0.1 : 0.17, at, out: bus });
    timers.push(setTimeout(() => onNote?.(i), at * 1000));
    at += dur;
  });
  return { length: at, stop: () => { timers.forEach(clearTimeout); bus.gain.setValueAtTime(0, c.currentTime); bus.disconnect(); } };
};
